import Vue from 'vue'
import Vuex from 'vuex'
import RestResource from '../RestResource';
const restResourceService = new RestResource();

Vue.use(Vuex)
const state = {
  account: null,
  accountBalance: { balance: null },
  accountDetails: { id: null },
  accountSettings: { Notifications: false, CheckIn: false, TakePayment: false, QuickLaunch: false, currencies: '' },
  sites: null,

  isLoadingAccount: false,
  isLoadingAccountBalance: false,
  isLoadingAccountDetails: false,

  promptedInstall: false,
  promptedPushNotifications: false,
  promptedBankDetails: false,
  promptedLocation: false,
  //Onboarding Progress
  onboardingProgress: null,
  //The prompt object for installing
  installPrompt: null,

  //If loggedIn state saved. Used in router guard
  accountLoggedIn: null,

  //Version of build
  packageVersion: process.env.PACKAGE_VERSION || '0',

  unReadMessages: null,
  allMessages: null
}

const getters = {
  getAccount: state => state.account,
  accountSettings: state => state.accountSettings,
  getAccountBalance: state => state.accountBalance,
  getAccountDetails: state => state.accountDetails,
  getSites: state => state.sites,

  getIsLoadingAccount: state => state.isLoadingAccount,
  getIsLoadingAccountBalance: state => state.isLoadingAccountBalance,
  getIsLoadingAccountDetails: state => state.isLoadingAccountDetails,

  installPrompt: state => state.installPrompt,
  //Prompts shown
  getPromptedInstall: state => state.promptedInstall,
  getPromptedPushNotifications: state => state.promptedPushNotifications,
  getPromptedBankDetails: state => state.promptedBankDetails,
  getPromptedLocation: state => state.promptedLocation,

  getAccountLoggedIn: state => state.accountLoggedIn,

  getOnboardingProgress: state => state.onboardingProgress,
  getUnreadMessages: state => state.unReadMessages,
  getAllMessages: state => state.allMessages,

  appVersion: (state) => {
    return state.packageVersion
  }
}

const mutations = {
  setAccount(state, account) {
    state.account = account;
  },
  setAccountSettings(state, accountSettings) {
    state.accountSettings = accountSettings;
  },
  initializeAccountLoggedIn(state) {
    if (localStorage.getItem('accountLoggedIn')) {
      state.accountLoggedIn = JSON.parse(localStorage.getItem('accountLoggedIn'));
      //this.replaceState(Object.assign(state.accountLoggedIn, JSON.parse(localStorage.getItem('accountLoggedIn'))))
    }
    else state.accountLoggedIn = false;
  },
  loggedIn(state) {
    state.accountLoggedIn = true; //In app.vue subscription is set up to update localStorage
  },
  loggedOut(state) {
    state.accountLoggedIn = false; //In app.vue subscription is set up to update localStorage
  },
  setAccountBalance(state, accountBalance) {
    state.accountBalance = accountBalance;
  },
  setAccountDetails(state, accountDetails) {
    state.accountDetails = accountDetails;
  },
  setSites(state, sites) {
    state.sites = sites;
  },
  setIsLoadingAccount(state, isLoading) {
    state.isLoadingAccount = isLoading;
  },
  setIsLoadingAccountBalance(state, isLoading) {
    state.isLoadingAccountBalance = isLoading;
  },
  setIsLoadingAccountDetails(state, isLoading) {
    state.isLoadingAccountDetails = isLoading;
  },
  setInstallPrompt(state, prompt) {
    state.installPrompt = prompt;
  },
  setPromptedInstall(state, hasPrompt) {
    state.promptedInstall = hasPrompt;
  },
  setPromptedPushNotifications(state, hasPrompt) {
    state.promptedPushNotifications = hasPrompt;
  },
  setPromptedBankDetails(state, hasPrompt) {
    state.promptedBankDetails = hasPrompt;
  },
  setPromptedLocation(state, hasPrompt) {
    state.promptedLocation = hasPrompt;
  },
  setOnboardingProgress(state, progress) {
    state.onboardingProgress = progress;
  },
  setUnreadMessages(state, unreadMess) {
    state.unReadMessages = unreadMess;
  },
  setAllMessages(state, allMessages) {
    state.allMessages = allMessages;
  }
}

const actions = {

  async fetchAccount({ commit, dispatch }) {
    commit('setIsLoadingAccount', true);
    const account = await restResourceService.getCurrentAccount();
    commit('setIsLoadingAccount', false);
    //If error occurs then logout from app as no account will be present
    if (account == null) {
      dispatch('logoutFromApp');
    } else {
      //If valid account then set it
      commit('setAccount', account);
      commit('setAccountSettings', account.settings);
    }
  },

  async fetchAccountBalance({ commit }) {
    commit('setIsLoadingAccountBalance', true);
    const accountBalance = await restResourceService.getBalance();
    if (accountBalance != null)
      accountBalance.balance = accountBalance.balance * -1;
    commit('setAccountBalance', accountBalance);
    commit('setIsLoadingAccountBalance', false);
  },

  async fetchAccountDetails({ commit }) {
    commit('setIsLoadingAccountDetails', true);
    const accountDetails = await restResourceService.getAccountAddress().catch(err => { console.log("ERROR: " + err) });
    commit('setIsLoadingAccountDetails', false);
    commit('setAccountDetails', accountDetails);
  },

  async fetchSites({ commit }) {
    const sites = await restResourceService.getPartnerSites().catch(err => { console.log("ERROR: " + err); });
    commit('setSites', sites);
  },

  updateAccountDetails({ commit }, accountDetails) {
    commit('setAccountDetails', accountDetails);
  },

  loginToApp({ commit }) {
    commit('loggedIn')
  },

  logoutFromApp({ commit }) {
    commit('setAccount', null);
    commit('setIsLoadingAccount', false);
    commit('setAccountBalance', { balance: null });
    commit('setIsLoadingAccountBalance', false);
    commit('loggedOut');
  },

  saveInstallPromptCaught({ commit }, prompt) {
    commit('setInstallPrompt', prompt);
  },
  async fetchOnboardingProgress({ commit }) {
    const progress = await restResourceService.getOnboardingProgress().catch(err => { console.log("ERROR: " + err); });
    commit('setOnboardingProgress', progress);
  },
  async fetchUnreadMessages({ commit }) {
    const messages = await restResourceService.getUnreadMessages();
    messages.sort((a, b) => new Date(a.dateAssigned) - new Date(b.dateAssigned));//Sorted list
    messages.reverse();//reversed to newest first
    commit('setUnreadMessages', messages);
  },
  async fetchAllMessages({ commit }) {
    const allMessages = await restResourceService.getAllMessages();
    allMessages.sort((a, b) => new Date(a.dateAssigned) - new Date(b.dateAssigned));//Sorted list
    allMessages.reverse();//reversed to newest first
    commit('setAllMessages', allMessages)
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
